import { render, staticRenderFns } from "./redactorsComponent.vue?vue&type=template&id=49f89dfa&scoped=true"
import script from "./redactorsComponent.vue?vue&type=script&lang=js"
export * from "./redactorsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f89dfa",
  null
  
)

export default component.exports